<template>
  <div
    style="display: table; width: 100%; height: 100%; background-color: #f9f9f9"
  >
    <div style="display: table-cell; vertical-align: middle">
      <div style="padding: 36px">
        <div
          style="
            width: 78px;
            height: 60px;
            margin: 0 auto;
            background: transparent
              url('data:image/png;base64,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')
              no-repeat center center;
          "
        ></div>
        <div
          style="
            margin-top: 21px;
            font-size: 24px;
            color: #222;
            font-family: 'NanumSquare-Regular', Arial, Verdana, sans-serif;
            text-align: center;
          "
        >
          세션 허용 시간이 만료되었습니다.
        </div>
        <div
          style="
            margin-top: 5px;
            font-size: 20px;
            color: #666;
            font-family: 'NanumSquare-Regular', Arial, Verdana, sans-serif;
            text-align: center;
          "
        >
          <strong>개인정보보호</strong>를 위해 다시한번
          <strong>로그인</strong> 해주세요.
        </div>
        <div style="width: 200px; margin: 30px auto 0 auto">
          <erp-button
            button-div="CLOSE"
            @click="onLoginClick"
            style="
              box-sizing: border-box;
              box-shadow: 0 6px 6px 0 rgba(0, 0, 0, 0.06);
              border: 1px solid #2e7458;
              border-radius: 3px;
              background-color: #2e7458;
              width: 100%;
              height: 46px;
              padding: 0 18px 0 18px;
              cursor: pointer;
            "
          >
            <div
              style="
                font-size: 16px;
                color: #fff;
                font-family: 'NanumSquare-Bold', Arial, Verdana, sans-serif;
              "
            >
              로그인
            </div>
          </erp-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ErpButton from "@/components/button/ErpButton.vue";

export default {
  name: "SessionExpiredView",
  components: {
    ErpButton,
  },
  methods: {
    onLoginClick() {
      this.$router.push({
        name: "login",
        query: {
          redirect: this.$route.query.redirect,
        },
      });
    },
  },
};
</script>

<style scoped></style>
